export const HEADERS = {
  ACCEPT_LANGUAGE: 'accept-language',
  COOKIE: 'cookie',
  CSRF_TOKEN: 'x-csrftoken',
  ENCODING: 'accept-encoding',
  FORWARDED_HOST: 'x-forwarded-host',
  FORWARDED_PROTO: 'x-forwarded-proto',
  GEOIP_CF_CITY: 'cf-ipcity',
  GEOIP_CF_COUNTRY: 'cf-ipcountry',
  GEOIP_CF_LATITUDE: 'cf-iplatitude',
  GEOIP_CF_LONGITUDE: 'cf-iplongitude',
  HOST: 'host',
  IDENTIFICATION_REQUEST_ID: 'x-request-id',
  IDENTIFICATION_VISITOR_ID: 'x-visitor-id',
  MARKET_COUNTRY_CODE: 'bm-market',
  NGINX_IP: 'x-forwarded-for',
  USER_AGENT: 'user-agent',
  VERIFIED_BOT: 'x-bm-bopip-verified-bot',
  APP_PLATFORM: 'app-platform',
} as const

/**
 * The following is linked to the bot challenge management handled by BOPIP.
 * If you want more details about this, please refer to their documentation.
 */
export const BOT_CHALLENGE = {
  TYPE: 'bot-need-challenge',
  MESSAGE: 'BOT_NEED_CHALLENGE error received during server side rendering',
  REDIRECT: '/testchallengepage',
}
